import React from 'react';
import { motion } from 'framer-motion';
import { ChatBubble } from './ChatBubble';
export function PainSection() {
  return <section className="w-full bg-[#E5DDD5] py-16 px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-127">
      {/* Background Pattern Overlay (subtle WhatsApp-like doodle pattern effect could go here) */}
      <div className="absolute inset-0 opacity-5 pointer-events-none bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]" data-id="element-128"></div>

      <div className="max-w-md mx-auto relative z-10" data-id="element-129">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-130">
          <h2 className="text-2xl sm:text-3xl font-bold text-[#1A1A1A] mb-2" data-id="element-131">
            Te pasa esto:
          </h2>
          <p className="text-gray-600" data-id="element-132">Una historia triste en 4 actos...</p>
        </motion.div>

        <div className="bg-[#efe7dd] rounded-2xl shadow-xl overflow-hidden border border-[#d4cbb8]" data-id="element-133">
          {/* Chat Header */}
          <div className="bg-[#075E54] p-4 flex items-center gap-3 text-white shadow-md" data-id="element-134">
            <div className="w-10 h-10 rounded-full bg-gray-300 flex items-center justify-center text-gray-600 font-bold text-sm" data-id="element-135">
              C
            </div>
            <div data-id="element-136">
              <h3 className="font-semibold text-sm" data-id="element-137">Cliente Potencial</h3>
              <p className="text-xs opacity-80" data-id="element-138">en línea</p>
            </div>
          </div>

          {/* Chat Body */}
          <div className="p-4 min-h-[400px] flex flex-col justify-end bg-[url('https://user-images.githubusercontent.com/15075759/28719144-86dc0f70-73b1-11e7-911d-60d70fcded21.png')] bg-repeat bg-opacity-10" data-id="element-139">
            <ChatBubble message="Hola, me interesa tu servicio 😊" isUser={false} timestamp="10:30 AM" delay={0.2} data-id="element-140" />

            <ChatBubble message="Hola 😊 sí, mira, lo que pasa es que..." isUser={true} timestamp="10:31 AM" status="read" delay={1.5} data-id="element-141" />

            <ChatBubble message="🎤 Audio (1:47)" isUser={true} timestamp="10:31 AM" status="read" delay={2.0} data-id="element-142" />

            <ChatBubble message="¿Y cuánto cuesta?" isUser={false} timestamp="10:45 AM" delay={3.5} data-id="element-143" />

            <ChatBubble message="$150 USD" isUser={true} timestamp="10:46 AM" status="read" delay={4.5} data-id="element-144" />

            {/* The silence / ghosting indicator */}
            <motion.div initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} transition={{
            delay: 6.0,
            duration: 0.5
          }} className="text-center py-4" data-id="element-145">
              <span className="inline-block px-3 py-1 bg-gray-200 rounded-full text-xs text-gray-500 shadow-sm" data-id="element-146">
                Visto 10:46 AM (y nunca más respondió)
              </span>
            </motion.div>
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.5
      }} className="mt-10 text-center bg-white p-6 rounded-xl shadow-lg border-l-4 border-red-500" data-id="element-147">
          <p className="text-lg font-medium text-gray-800 leading-relaxed" data-id="element-148">
            No es tu producto. <br data-id="element-149" />
            No es el algoritmo. <br data-id="element-150" />
            No es "la crisis". <br data-id="element-151" />
            <span className="font-bold text-red-600 block mt-2" data-id="element-152">
              Es que estás teniendo una conversación sin estructura.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}